module.exports = __webpack_public_path__ + "img/T5-D-rc_19.50701794.png";